<p>
    <strong>{{ appCopy.panelHeader['amountChargedText'+selectedLanguage] }}</strong><br>
    {{currencySymbol === 'CHF' ? currencySymbol+' ' : currencySymbol}}{{ excessCustomsPayment.totalCharge.toFixed(2) }}
</p>
<P>
    <strong>{{ appCopy.panelHeader['paymentStatusText'+selectedLanguage] }}</strong><br>
    {{ excessCustomsPayment.paymentStatus === 1 ? appCopy.panelHeader['pendingText'+selectedLanguage] : excessCustomsPayment.paymentStatus === 2 ? appCopy.panelHeader['settledText'+selectedLanguage] : '' }}
</P>

<p><strong>{{ appCopy.panelHeader['reasonText'+selectedLanguage] }}</strong><br>
    <span *ngIf="excessCustomsPayment.overweightBags > 0">
        {{ excessCustomsPayment.overweightBags }} {{ appCopy.panelHeader['overweightText'+selectedLanguage] }} {{ excessCustomsPayment.overweightBags > 1 ? appCopy.panelHeader['bagsSelectText'+selectedLanguage] : appCopy.panelHeader['bagSelectText'+selectedLanguage] }}
    </span><br>
    <span *ngIf="excessCustomsPayment.overweightBags > 0">
        {{ excessCustomsPayment.excessBags }} {{ appCopy.panelHeader['excessText'+selectedLanguage] }} {{ excessCustomsPayment.excessBags > 1 ? appCopy.panelHeader['bagsSelectText'+selectedLanguage] : appCopy.panelHeader['bagSelectText'+selectedLanguage] }}
    </span><br>
    <span *ngIf="excessCustomsPayment.note !== '' && excessCustomsPayment.note !== null">{{ appCopy.panelHeader['noteText'+selectedLanguage] }}:
        {{ excessCustomsPayment.note }}</span>
</p>
<p *ngIf="receiptImg"><img class="img-responsive" [src]="receiptImg"></p>